// A family requirement accepts its main variants. A named variant remains exact.
export function hasEligibleMain(required = [], selectedIds = [], rules = {}) {
    return selectedIds.some(id => {
        const rule = rules[String(id)] || {};
        if ((rule.type || 'main') !== 'main') return false;
        return required.includes(id) || (rule.parent_id != null && required.includes(rule.parent_id) &&
            (rules[String(rule.parent_id)]?.type || 'main') === 'main');
    });
}

export function groupServices(services, rules = {}) {
    const ids = new Set(services.map((s) => s.id));
    const groups = new Map();
    services.forEach((s) => {
        const parent = rules[String(s.id)]?.parent_id;
        const id = parent && ids.has(parent) ? parent : s.id;
        if (!groups.has(id)) groups.set(id, { parent: services.find((p) => p.id === id), options: [] });
        groups.get(id).options.push(s);
    });
    return [...groups.values()].map((g) => ({ ...g, options:g.options.slice().sort((a,b)=>(rules[String(a.id)]?.display_order || 0)-(rules[String(b.id)]?.display_order || 0)), hasVariants: g.options.length > 1 || rules[String(g.parent.id)]?.pricing_mode === 'from', parent: {...g.parent, name: rules[String(g.parent.id)]?.display_name || g.parent.name}, fromPrice: Math.min(...g.options.map((s) => Number(s.price) || 0)) })).sort((a,b)=>(rules[String(a.parent.id)]?.menu_order ?? 10000)-(rules[String(b.parent.id)]?.menu_order ?? 10000));
}
